import { render, staticRenderFns } from "./FluxoCaixaProjecaoDadosMovimentacao.vue?vue&type=template&id=4deaf463&scoped=true&"
import script from "./FluxoCaixaProjecaoDadosMovimentacao.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixaProjecaoDadosMovimentacao.vue?vue&type=script&lang=js&"
import style0 from "./FluxoCaixaProjecaoDadosMovimentacao.vue?vue&type=style&index=0&id=4deaf463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deaf463",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDialog,VIcon,VSpacer})
